/**
 * PC 用レフトナビの制御
 * MEMO: ポップアップ制御とオンデザへのリンククリック時に商品タイプを$_POST
 */

import type { AppEnv } from '../../utils/env'

/**
 * レフトナビの制御を初期化
 */
export const initLeftNav = (env: AppEnv): void => {
    /**
     * ONdesign（オンデザ）リンク制御
     * MEMO: 2026-10-06 現在、商材が名刺のみのためほぼ無意味
     *       （将来的に商材が増えた場合はここで投げた $_POST に応じて何かするための仕込み）
     */
    const odSubmits = document.querySelectorAll<HTMLElement>('.j-od_submit')
    odSubmits.forEach((elm) => {
        elm.addEventListener('click', () => {
            const myItemType = elm.dataset.itemType || ''
            const parent = elm.parentElement
            if(!parent) return

            const form = document.createElement('form')
            form.action = `${env.root}/od-app/`
            form.method = 'post'
            form.id = 'od-send_form'

            const input = document.createElement('input')
            input.type = 'hidden'
            input.name = 'item_type'
            input.value = myItemType

            form.appendChild(input)
            parent.appendChild(form)
            form.submit()
        })
    })

  //ポップアップ制御
    const popTgls = document.querySelectorAll<HTMLElement>('.p-nav_side_block .j-pop-tgl')
    popTgls.forEach((tgl) => {
        tgl.addEventListener('mouseenter', () => { tgl.classList.add('is-hover') })
        tgl.addEventListener('mouseleave', () => { tgl.classList.remove('is-hover') })
    })
}
